// extracted by mini-css-extract-plugin
export default {"content":"VrpPayments_content__3kj42 zb-container","tppHeader":"VrpPayments_tppHeader__svdN9"};